import { StatusActions, StatusActionTypes } from "actions";

interface StatusState {
  status: any;
  loading: boolean;
  error: string | null;
}

const initialState: StatusState = {
  status: null,
  loading: false,
  error: null,
};

const statusReducer = (
  state = initialState,
  action: StatusActions
): StatusState => {
  switch (action.type) {
    case StatusActionTypes.FETCH_STATUS_REQUEST:
      return { ...state, loading: true, error: null };
    case StatusActionTypes.FETCH_STATUS_SUCCESS:
      return { ...state, loading: false, status: action.payload };
    case StatusActionTypes.FETCH_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default statusReducer;
